import React, { useState, useEffect, useMemo } from "react";
import DataTable from "../components/DataTable.js";
import { fetchDataFromAPI, saveData, deleteData } from "../components/api.js";
import subscriptionStatus from "../components/SubscriptionStatus.js";
const getRangeInputProps = (col) => {
  if (col.type === "range") {
    return { min: 0, max: 5, step: 0.5 }; // Limit range inputs to 0-5 with step of 0.1
  }
  return {}; // Return empty object for non-range types
};
const ProductionBatch = () => {
  const [productionBatches, setProductionBatches] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState();
  const [sortField, setSortField] = useState("created_at"); // Track the current sorted field
  const [sortOrder, setSortOrder] = useState("desc"); // Track the current sort order
  const [materialsOptions, setMaterialsOptions] = useState([]);
  const [suppliersOptions, setSuppliersOptions] = useState([]);

  const [error, setError] = useState(null);
  const isSubscribed = subscriptionStatus();
  useEffect(() => {
    fetchData();
    console.log("referching data", currentPage, filters, sortField, sortOrder);
  }, [filters, sortField, sortOrder]);

  const fetchData = async (page = 1, itemsPerPage = 10, filters) => {
    try {
      console.log("fetchData", filters, sortField, sortOrder);
      const token = localStorage.getItem("token");
      console.log("filters", filters);

      // Prepare query parameters

      // Dynamically construct query parameters, excluding empty sortField and sortOrder
      const filterParamsObj = {
        page,
        limit: 10,
        ...filters,
        includeDeleted: "false",
      };
      console.log("limit", filterParamsObj.limit);

      // Add sortField and sortOrder only if they are not empty
      if (sortField) {
        filterParamsObj.sortField = sortField;
      }
      if (sortOrder) {
        filterParamsObj.sortOrder = sortOrder;
      }
      console.log("Filter Params:", new URLSearchParams(filterParamsObj));
      console.log("filterParamsObj.sortOrder:", filterParamsObj.sortOrder);

      // Create the query string
      const filterParams = new URLSearchParams(filterParamsObj).toString();

      // Fetch production-batches and materials concurrently
      const { data: productionBatches, pagination } = await fetchDataFromAPI(
        `/api/production-batches`,
        filterParams,
        token
      );

      const { data: materials } = await fetchDataFromAPI(
        `/api/materials`,
        {},
        token
      );
      const { data: suppliers } = await fetchDataFromAPI(
        `/api/suppliers`,
        {},
        token
      );

      setProductionBatches(productionBatches || []);
      setMaterialsOptions(materials || []);
      setSuppliersOptions(suppliers || []);
      setTotalPages(pagination?.totalPages || 1);

      console.log("productionBatches:", productionBatches);
      console.log("Materials:", materials);
      console.log("suppliers:", suppliers);
    } catch (err) {
      console.error("Error fetching data:", err.message);
      setError(err.message);
    }
  };

  const handleAddRow = async () => {
    try {
      const newRow = {
        name: "New batch", // Default name for the batch
        quantity_per_percent: "", // Default value for quantity per percent
        price_per_ml: "", // Default value for price per ml
        total_cost: "", // Default value for total cost
        batch_no: "", // Default value for batch number
        production_date: "", // Default production date (empty string means no date selected)
        quantity_produced: "", // Default value for quantity produced
        notes: "", // Default value for notes
        suppliers: "", // Default value for suppliers (empty string means no supplier selected)
        cost_per_unit: "", // Default value for cost per unit
        materials: "", // Default value for materials (empty string means no materials selected)
        status: "in-progress",
        expiry_date: "", // Default expiry date (empty string means no expiry date set)
      };

      await saveData("/api/production-batches", newRow, "POST");
      fetchData();
    } catch (err) {
      console.error("Error adding row:", err);
    }
  };

  const handleEdit = async (id, updatedData) => {
    console.log(" handleEdit id", id);
    try {
      await saveData(`/api/production-batches/${id}`, updatedData);
      fetchData();
    } catch (err) {
      console.error("Error editing supplier:", err);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteData(`/api/production-batches/${id}`);
      fetchData();
    } catch (err) {
      console.error("Error deleting supplier:", err);
    }
  };
  const handlePageChange = (newPage) => {
    console.log("Parent - Page changed to:", newPage); // Log in parent
    setCurrentPage(newPage); // Update the current page
    fetchData(newPage, 10); // Fetch new data
  };
  const handleSort = (field, order) => {
    console.log("handleSort,field,order", field, order);
    setSortField(field); // Update the sorted field
    setSortOrder(order); // Update the sort order (asc/desc)
  };
  const handleFilterChange = (newFilters) => {
    console.log("handleFilterChange", newFilters);
    setFilters(newFilters); // Update filters in the parent state
    fetchData(currentPage, newFilters); // Refetch data with new filters
  };
  const valueStyles = {
    "in-progress": {
      backgroundColor: "orange", // Blue for in-progress
      color: "white",
    },
    completed: {
      backgroundColor: "green", // Green for completed
      color: "white",
    },
    pending: {
      backgroundColor: "yellow", // Orange for pending
      color: "white",
    },
    // Add any additional styles as needed
  };

  const columns = [
    { header: "Name", accessor: "name" },
    { header: "Quantity per percent", accessor: "quantity_per_percent" },
    { header: "Price per ml", accessor: "price_per_ml" },

    { header: "total cost", accessor: "total_cost" },
    { header: "Batch Num", accessor: "batch_no" },
    {
      header: "Production date",
      accessor: "production_date",
      type: "Date",
    },
    { header: "Quantity producted", accessor: "quantity_produced" },
    { header: "Notes", accessor: "notes" },
    {
      header: "Suppliers",
      accessor: "suppliers",
      type: "list",
      options: suppliersOptions,
    },

    { header: "Cost per unit", accessor: "cost_per_unit" },

    {
      header: "Materials",
      accessor: "materials",
      type: "list",
      options: materialsOptions,
    },

    {
      header: "Status",
      accessor: "status",
      type: "dropdown",
      options: [
        { value: "in-progress", label: "In Progress" },
        { value: "completed", label: "Completed" },
        { value: "pending", label: "Pending" },
        { value: "active", label: " " },
      ],
      valueStyles,
    },
    {
      header: "Expiry Date",
      accessor: "expiry_date",
      type: "Date",
    },
  ];
  console.log("columns", columns);
  return (
    <DataTable
      title="productionBatches"
      columns={columns}
      data={productionBatches}
      currentPage={currentPage}
      setData={setProductionBatches}
      totalPages={totalPages}
      onSort={handleSort}
      sortOrder={sortOrder}
      sortField={sortField}
      onPageChange={handlePageChange}
      filters={filters}
      onFilterChange={handleFilterChange}
      onAddRow={handleAddRow}
      actions={[
        {
          label: "Edit",
          onClick: (row) => {
            const updatedData = { ...row, name: "Updated Name" };
            handleEdit(row.id, updatedData);
          },
        },
        {
          label: "Delete",
          onClick: (row) => handleDelete(row.id),
        },
      ]}
      apiEndpoint="/api/production-batches"
      itemsPerPage={10}
      fetchData={fetchData}
      getRangeInputProps={getRangeInputProps}
      selectedItems={productionBatches.materials}
    />
  );
};

export default ProductionBatch;
